// When comparing some latin letters with equivalent letters with diacritics,
// we should make sure A and Á are treated the same.  So we can normalize the
// string and then remove the diacritics
// https://thread.engineering/2018-08-29-searching-and-sorting-text-with-diacritical-marks-in-javascript/
export function normalizeStringWithoutDiacritics(s) {
  return s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
